import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/assignee-cell.scss';

Component('tr-grid-assignee-cell', {
  mixins: [baseMixin],

  properties: {
    hideResultText: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-todo-assignee-select-field:change': this.handleChange.bind(this),
      'tr-selector-field-list:opened': () => { this.editing = true; },
      'tr-selector-field-list:closed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.tr-todo-assignee-select-field', this);
  },

  handleClick({ target }) {
    const field = closest(target, '.tr-todo-assignee-select-field', this);
    if (field && !field.classList.contains('grid-cell-editor')) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    if (!this.editor) return;

    this.editor.toggleList(true);
  },

  setValue(value) {
    this.value = value;

    if (this.editorInitialized) {
      this.editor.setValue(value);
    } else {
      this.prepareEditor();
    }
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        if (this.value) {
          const selectedOption = this.editor
            .querySelector(`select option[value="${this.value}"]`);
          if (selectedOption) selectedOption.selected = true;
        }

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.replaceChild(this.editor, this.firstElementChild);
      }
    });
  },

  handleChange(event) {
    this.value = event.detail;
    this.namespacedTrigger('cellValueChange', {
      detail: { value: event.detail },
      bubbles: true,
    });
  },

  toggleMinimalStatus(minimal) {
    this.hideResultText = minimal;
  },
});
